import type { LitigationApiItem } from "../../types/litigation";
import { getJsonReal } from "../client";

/**
 * Geographic litigation risk for a submission's facilities.
 *
 * `GET /v2/submissions/{id}/litigation/?years=N` (deployed on dev jun-18;
 * staging pending). `years` is a REQUIRED query param (lookback window).
 * Returns one row per facility. Hits the real backend directly
 * (`getJsonReal`) — there's no mock handler for this v2 path.
 */
export function getLitigation(submissionId: string, years: number): Promise<LitigationApiItem[]> {
    const params = new URLSearchParams({ years: String(years) });
    return getJsonReal<LitigationApiItem[]>(`/v2/submissions/${encodeURIComponent(submissionId)}/litigation/?${params}`);
}
